module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_04-8a6a58aa657c7a73ee9ffba66942c601.png";